import { render, staticRenderFns } from "./PublishList.vue?vue&type=template&id=8d4506c8&scoped=true"
import script from "./PublishList.vue?vue&type=script&lang=js"
export * from "./PublishList.vue?vue&type=script&lang=js"
import style0 from "./PublishList.vue?vue&type=style&index=0&id=8d4506c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4506c8",
  null
  
)

export default component.exports